import { Flex } from "@paguelofacil/pf-components";

import { useRedirectWithoutSession } from "../hooks/useRedirectWithoutSession";
import { BoxInit } from "../components/BoxInit";
import AppWithErrorBoundary from "../components/Error/ErrorBoudary";

import "../assets/scss/home.scss";

const Home = () => {
    useRedirectWithoutSession();
    return (
        <AppWithErrorBoundary>
            <Flex className="container-home">
                <BoxInit />
                <img
                    src="https://assets.paguelofacil.com/images/widget/logo-cryptofacil-billscoins.webp"
                    alt="logo cryptofacil billscoins"
                    className="image-cryptofacil-billscoins"
                    loading="lazy"
                />
            </Flex>
        </AppWithErrorBoundary>
    );
};

export default Home;
